import { Skeleton } from "@/components/ui/skeleton";

/**
 * PnrCardSkeleton — mirrors PnrCard ticket-perforation layout.
 * Header line, train number+name, route arrow, status pill, action row.
 * Pass index for staggered shimmer.
 */
const PnrCardSkeleton = ({ index = 0 }) => {
  const delay = index * 80; // 80ms stagger between cards
  return (
    <div className="relative bg-zinc-900/50 border border-zinc-800 rounded-xl p-5 overflow-hidden">
      {/* Top row: train number + status */}
      <div className="flex items-center justify-between mb-4">
        <Skeleton className="h-5 w-24" delay={delay} />
        <Skeleton className="h-6 w-20 rounded-full" delay={delay + 40} />
      </div>
      {/* Train name */}
      <Skeleton className="h-6 w-3/5 mb-3" delay={delay + 80} />
      {/* Route: boarding → destination */}
      <div className="flex items-center gap-3 mb-4">
        <Skeleton className="h-4 w-20" delay={delay + 120} />
        <Skeleton className="h-3 w-6" delay={delay + 140} />
        <Skeleton className="h-4 w-20" delay={delay + 160} />
      </div>
      {/* Meta row */}
      <div className="flex items-center justify-between">
        <Skeleton className="h-3 w-32" delay={delay + 200} />
        <Skeleton className="h-3 w-16" delay={delay + 220} />
      </div>
    </div>
  );
};

export default PnrCardSkeleton;
